/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CreateStickyRequest,
  Sticky,
  StickyEntityType,
  StickyHistory,
  UpdateStickyRequest,
} from "../models/index";
import {
  CreateStickyRequestFromJSON,
  CreateStickyRequestToJSON,
  StickyFromJSON,
  StickyToJSON,
  StickyEntityTypeFromJSON,
  StickyEntityTypeToJSON,
  StickyHistoryFromJSON,
  StickyHistoryToJSON,
  UpdateStickyRequestFromJSON,
  UpdateStickyRequestToJSON,
} from "../models/index";

export interface CreateStickyOperationRequest {
  createStickyRequest: CreateStickyRequest;
}

export interface DeleteStickyRequest {
  stickyId: string;
}

export interface ListStickiesRequest {
  entityType: StickyEntityType;
  entityId: string;
}

export interface StickyHistoryRequest {
  stickyId: string;
}

export interface UpdateStickyOperationRequest {
  stickyId: string;
  updateStickyRequest: UpdateStickyRequest;
}

/**
 *
 */
export class StickiesApi extends runtime.BaseAPI {
  /**
   */
  async createStickyRaw(
    requestParameters: CreateStickyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Sticky>> {
    if (requestParameters["createStickyRequest"] == null) {
      throw new runtime.RequiredError(
        "createStickyRequest",
        'Required parameter "createStickyRequest" was null or undefined when calling createSticky().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/stickies/create`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateStickyRequestToJSON(
          requestParameters["createStickyRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StickyFromJSON(jsonValue),
    );
  }

  /**
   */
  async createSticky(
    requestParameters: CreateStickyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Sticky> {
    const response = await this.createStickyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async deleteStickyRaw(
    requestParameters: DeleteStickyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["stickyId"] == null) {
      throw new runtime.RequiredError(
        "stickyId",
        'Required parameter "stickyId" was null or undefined when calling deleteSticky().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["stickyId"] != null) {
      queryParameters["stickyId"] = requestParameters["stickyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/stickies/delete`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteSticky(
    requestParameters: DeleteStickyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteStickyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async listStickiesRaw(
    requestParameters: ListStickiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Sticky>>> {
    if (requestParameters["entityType"] == null) {
      throw new runtime.RequiredError(
        "entityType",
        'Required parameter "entityType" was null or undefined when calling listStickies().',
      );
    }

    if (requestParameters["entityId"] == null) {
      throw new runtime.RequiredError(
        "entityId",
        'Required parameter "entityId" was null or undefined when calling listStickies().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["entityType"] != null) {
      queryParameters["entityType"] = requestParameters["entityType"];
    }

    if (requestParameters["entityId"] != null) {
      queryParameters["entityId"] = requestParameters["entityId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/stickies/list`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(StickyFromJSON),
    );
  }

  /**
   */
  async listStickies(
    requestParameters: ListStickiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Sticky>> {
    const response = await this.listStickiesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async stickyHistoryRaw(
    requestParameters: StickyHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<StickyHistory>>> {
    if (requestParameters["stickyId"] == null) {
      throw new runtime.RequiredError(
        "stickyId",
        'Required parameter "stickyId" was null or undefined when calling stickyHistory().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["stickyId"] != null) {
      queryParameters["stickyId"] = requestParameters["stickyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/stickies/history`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(StickyHistoryFromJSON),
    );
  }

  /**
   */
  async stickyHistory(
    requestParameters: StickyHistoryRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<StickyHistory>> {
    const response = await this.stickyHistoryRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateStickyRaw(
    requestParameters: UpdateStickyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["stickyId"] == null) {
      throw new runtime.RequiredError(
        "stickyId",
        'Required parameter "stickyId" was null or undefined when calling updateSticky().',
      );
    }

    if (requestParameters["updateStickyRequest"] == null) {
      throw new runtime.RequiredError(
        "updateStickyRequest",
        'Required parameter "updateStickyRequest" was null or undefined when calling updateSticky().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["stickyId"] != null) {
      queryParameters["stickyId"] = requestParameters["stickyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/stickies/update`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateStickyRequestToJSON(
          requestParameters["updateStickyRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateSticky(
    requestParameters: UpdateStickyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateStickyRaw(requestParameters, initOverrides);
  }
}
